import * as React from "react";
import { connect } from "react-redux";
import { RootState } from "src/ipm-shared/store/model/reducers";
import T from "src/ipm-shared/Utils/Intl";
import * as selectors from "../selectors";
import { IBaseProps } from "../../Form/controls/lib/Base";
import Select from "src/ipm-shared/components/Form/controls/Select";
import Skeleton from "antd/es/skeleton";

import * as actions from "../actions";

type ISelect = {
  SelectComponent?: any;
};

const mapStateToProps = (state: RootState) => ({
  businessTypes: selectors.getBusinessTypes(state),
  isFetchingBusiness: selectors.getIsFetchBusiness(state)
});

const mapDispatchToProps = {
  fetchBusinessTypes: actions.fetchBusinessTypes
};

type IProps = IBaseProps &
  ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  ISelect;

class SelectBusinessType extends React.Component<IProps> {
  public componentDidMount() {
    this.props.fetchBusinessTypes();
  }

  public render() {
    const {
      businessTypes,
      SelectComponent = Select,
      isFetchingBusiness
    } = this.props;

    return this.props.businessTypes.length > 0 ? (
      <Skeleton loading={isFetchingBusiness} paragraph={{ rows: 1 }}>
        <SelectComponent
          {...this.props}
          placeholder={T.transl("BUSINESS_TYPE_LABEL")}
          options={businessTypes.map(b => ({
            label: T.transl(`BUSINESS_TYPE_${b.id}`),
            value: b.id
          }))}
        />
      </Skeleton>
    ) : (
      <Skeleton loading={true} paragraph={{ rows: 1 }}></Skeleton>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectBusinessType);
